var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSubAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5251 22.65H16.5765L16.6172 22.6184L17.5652 21.8808C19.6843 20.2327 20.9 17.7469 20.9 15.0625V14.7786V14.6811L20.8109 14.6415L16.9999 12.947C16.6505 12.0484 16.0836 11.2502 15.3496 10.6241C14.6836 10.0559 13.8992 9.64588 13.0555 9.42282C13.5465 9.035 13.9527 8.54873 14.2471 7.99396C14.5935 7.34137 14.7747 6.61387 14.775 5.87506V5.875C14.775 3.37978 12.7452 1.35 10.25 1.35C7.75478 1.35 5.725 3.37978 5.725 5.875V5.87506C5.72531 6.61282 5.90608 7.3393 6.25154 7.99118C6.54529 8.54548 6.95054 9.03153 7.44051 9.41946C4.94497 10.0823 3.1 12.3606 3.1 15.0625V19.5C3.1 21.2397 4.5103 22.65 6.25 22.65H16.5251ZM15.9067 20.9536L15.9066 20.9536C14.1747 19.6069 13.1417 17.6138 13.0345 15.4399L16.3759 13.9553L19.7155 15.4403C19.6079 17.6142 18.5753 19.6069 16.8434 20.954C16.8434 20.954 16.8434 20.954 16.8433 20.954L16.375 21.3181L15.9067 20.9536ZM11.85 15.0625C11.85 17.5363 12.885 19.839 14.705 21.475H6.125C5.10327 21.475 4.275 20.6467 4.275 19.625V15.0625C4.275 12.4919 6.36691 10.4 8.9375 10.4H11.5625C13.3381 10.4 14.9336 11.4071 15.7179 12.9615L11.9391 14.6415L11.85 14.6811V14.7786V15.0625ZM6.9 5.875C6.9 4.02803 8.40303 2.525 10.25 2.525C12.097 2.525 13.6 4.02803 13.6 5.875C13.6 7.72197 12.097 9.225 10.25 9.225C8.40303 9.225 6.9 7.72197 6.9 5.875Z",
    fill: "#585858",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9625 15.5V15.35H16.8125H15.9375H15.7875V15.5V16.6625H14.625H14.475V16.8125V17.6875V17.8375H14.625H15.7875V19V19.15H15.9375H16.8125H16.9625V19V17.8375H18.125H18.275V17.6875V16.8125V16.6625H18.125H16.9625V15.5Z",
    fill: "#585858",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSubAdmin);
export default __webpack_public_path__ + "static/media/manage-sub-admin.0ad6a1d6b0b7aee915f0aaa2b30c634c.svg";
export { ForwardRef as ReactComponent };